/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Load_ErrorInputs */

const en_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the catalog. Try again.`)
};

const zh_hans1_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录加载失败，请重试。`)
};

const pt_br2_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o catálogo. Tente de novo.`)
};

const es_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el catálogo. Inténtalo de nuevo.`)
};

const fr_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger le catalogue. Réessayez.`)
};

const de_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Katalog konnte nicht geladen werden. Versuch es erneut.`)
};

const ru_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить каталог. Попробуйте ещё раз.`)
};

const it_search_load_error = /** @type {(inputs: Search_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il catalogo. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the catalog. Try again." |
*
* @param {Search_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_load_error = /** @type {((inputs?: Search_Load_ErrorInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Load_ErrorInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_load_error(inputs)
	if (locale === "pt-BR") return pt_br2_search_load_error(inputs)
	if (locale === "es") return es_search_load_error(inputs)
	if (locale === "fr") return fr_search_load_error(inputs)
	if (locale === "de") return de_search_load_error(inputs)
	if (locale === "ru") return ru_search_load_error(inputs)
	if (locale === "it") return it_search_load_error(inputs)
	return en_search_load_error(inputs)
});